export const log = (...arg: any[]) => {
  console.log('%c[BuryPoint]', 'color: #a6e22e;', ...arg)
}

export const warn = (...arg: any[]) => {
  console.warn('%c[BuryPoint]', 'color: #a6e22e;', ...arg)
}

export const isObject = (arg: any) => Object.prototype.toString.call(arg) === '[object Object]'
export const isArray = (arg: any) => Object.prototype.toString.call(arg) === '[object Array]'
